import moment from 'moment';
import React from 'react';
import { ReactComponent as NextIcon } from '../../../../assets/svg/calendar_right.svg';
import { getDateFormat } from '../../../../helpers/utils-helpers';
import { FeedCardHeaderSC } from './feed.styled';

type TProps = {
  title: React.ReactNode;
  date?: string | Date;
  onClick?: () => void;
  children?: React.ReactNode;
};

const FeedCardHeader: React.FC<TProps> = ({ title, date, children, onClick }) => {
  return (
    <FeedCardHeaderSC
      as={onClick ? 'button' : 'div'}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <div className="content">
        <div className="fch-label">{title}</div>
        {date ? <time className="fch-time">{moment(date).format(getDateFormat())}</time> : children}
      </div>
      {onClick ? (
        <div className="navigation">
          <NextIcon width={15} height={15} />
        </div>
      ) : null}
    </FeedCardHeaderSC>
  );
};

export default FeedCardHeader;
